const historyEvents = {
  bindings: {
    selection: '<',
    settings: '<',
    criteria: '<',
    filters: '<',
    area: '<',
    gridlet: '<',
  },
  templateUrl: '/modules/gridlets/history-events/history-events.html',
  controller: 'HistoryEventsController',
};

angular
  .module('gridlets.module')
  .component('historyEvents', historyEvents);